import { Navigate, useLocation } from "react-router-dom"

import { legacyBookingTarget } from "./legacyBookingTarget"

/**
 * Booking v2 is the only booking flow (product decision, 27 Oct 2026). The v1 wizard's URL stays
 * valid for bookmarks and old links, and always opens the equivalent booking step, whatever the
 * `booking_v2` flag says or whether it has loaded.
 */
export function LegacyBookingRedirect() {
  const { search, hash } = useLocation()
  return <Navigate to={{ ...legacyBookingTarget(search), hash }} replace />
}
